<template>
    <v-chip color="accent" class="pa-0 mt-1">
        <v-btn icon
               size="x-small"
               variant="text"
               color="primary"
               @mousedown="startDecreasing"
               @mouseup="stopChanging"
               @mouseleave="stopChanging"
               @touchstart="startDecreasing"
               @touchend="stopChanging"
               :disabled="modelValue <= min">
            <v-icon size="x-small">mdi-minus</v-icon>
        </v-btn>

        <span class="px-2 text-primary font-weight-medium">{{ internalValue }}</span>

        <v-btn icon
               size="x-small"
               variant="text"
               color="primary"
               @mousedown="startIncreasing"
               @mouseup="stopChanging"
               @mouseleave="stopChanging"
               @touchstart="startIncreasing"
               @touchend="stopChanging"
               :disabled="modelValue >= max">
            <v-icon size="x-small">mdi-plus</v-icon>
        </v-btn>
    </v-chip>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
  modelValue: number;
  min: number;
  max: number;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: number];
}>();

const internalValue = ref(props.modelValue);
let interval: ReturnType<typeof setInterval> | null = null;
let holding = false;

watch(() => props.modelValue, (val) => {
  internalValue.value = val;
});

const changeValue = (delta: number) => {
  const newValue = internalValue.value + delta;
  if (newValue >= props.min && newValue <= props.max) {
    internalValue.value = newValue;
  }
};

const startIncreasing = () => {
  holding = true;
  changeValue(1);
  interval = setInterval(() => changeValue(1), 200);
};

const startDecreasing = () => {
  holding = true;
  changeValue(-1);
  interval = setInterval(() => changeValue(-1), 200);
};

const stopChanging = () => {
  if (holding) {
    clearInterval(interval!);
    holding = false;
    emit('update:modelValue', internalValue.value);
  }
};
</script>